import React, { useCallback, useEffect, useState } from "react";
import "./PersonalInformationTab.scss";
import Input from "common/components/Input/Input";
import PasswordInput from "common/components/PasswordInput/PasswordInput";

// image imports
import PersonalInformationIcon1 from "assets/images/PersonalInformationTab-icon1.png";
import PersonalInformationIcon2 from "assets/images/PersonalInformationTab-icon2.png";
import { useTypedDispatch, useTypedSelector } from "store";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { changePassword, changeUser, logout } from "store/users/thunkActions";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Button from "common/components/Button";
import CrossPink from "assets/icons/components/crossPink.svg";
import PersonalInformationMobileTab from "./personalInformationMobileTab";
import { showMobile } from "helpers/adaptation";

const schema = yup.object().shape({
  password: yup
    .string()
    .required("*הסיסמה הנוכחית שהקלדת אינה נכונה")
    .min(6, "*אורך הסיסמה צריך להיות בין 6-12 תווים")
    .max(12, "*אורך הסיסמה צריך להיות בין 6-12 תווים"),
  repeatPass: yup
    .string()
    .required("*לא סופקה סיסמה.")
    .oneOf([yup.ref("newPass"), null], "*אימות סיסמה נכשל"),
  newPass: yup
    .string()
    .required("*לא סופקה סיסמה.")
    .min(6, "*אורך הסיסמה צריך להיות בין 6-12 תווים")
    .max(12, "*אורך הסיסמה צריך להיות בין 6-12 תווים")
});

const defaultVal = {
  password: "",
  repeatPass: "",
  newPass: ""
};

const schemaUser = yup.object().shape({
  phone: yup.string().required("*זהו שדה חובה"),
  name: yup.string().required("*זהו שדה חובה")
});

function PersonalInformationTab() {
  const [modalPass, setModalPass] = useState(false);

  const { client } = useTypedSelector((store) => store.user);
  const dispatch = useTypedDispatch();
  const [inccorectPhone, setInccorectPhone] = useState(false);
  const navigate = useNavigate();
  const [messageServer, setMessageServer] = useState<any>({});
  const [messageServerPass, setMessageServerPass] = useState<any>({});
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: defaultVal,
    resolver: yupResolver(schema)
  });

  const {
    control: controlUser,
    handleSubmit: handleSubmitUser,
    formState: { errors: errorsUser },
    setValue,
    setError
  } = useForm({
    defaultValues: {
      phone: client?.phoneNumber ? client?.phoneNumber || undefined : "0",
      name: `${client.firstName} ${client.lastName}`
    },
    resolver: yupResolver(schemaUser)
  });

  useEffect(() => {
    if (client.firstName) {
      setValue("name", `${client.firstName} ${client.lastName}`);
      setValue("phone", client?.phoneNumber);
    }
  }, [client.firstName, client.lastName, client?.phoneNumber, setValue]);

  const onChangePassword = useCallback(
    async (data: any) => {
      try {
        const res: any = await dispatch(
          changePassword(data?.password, data?.newPass, data?.repeatPass)
        );
        if (res?.status === "Error") {
          setMessageServerPass({
            message: res?.message
          });
        } else {
          setModalPass(true);
        }
      } catch (err) {
        // console.log("err", err);
      }
    },
    [dispatch]
  );
  const onChangeUser = useCallback(
    async (data: any) => {
      try {
        if (data?.phone && data?.phone[0] !== "0") {
          return setInccorectPhone(true);
        }
        if (
          (data?.phone?.length >= 2 && (data?.phone[0] !== "0" || data?.phone[1] !== "5")) ||
          data?.phone?.length < 10
        ) {
          return setError("phone", { message: "טלפון לא תקין" });
        }
        setInccorectPhone(false);
        const res: any = await dispatch(changeUser(data?.phone));
        if (res?.status === "Error") {
          setMessageServer({
            message: res?.message
          });
        } else {
          setMessageServer({
            message: "הפרטים עודכנו בהצלחה"
          });
        }
      } catch (err) {
        // console.log("err", err);
      }
    },
    [dispatch]
  );

  const onCloseModal = useCallback(async () => {
    dispatch(logout());
    navigate("/?loginModal=true");
  }, [dispatch, navigate]);

  const onChangeNumber = useCallback(
    (e: any, field: any) => {
      setMessageServer({
        message: ""
      });
      setInccorectPhone(false);
      if (e.target.value === "e") return;
      if (
        field.value &&
        field.value?.length > 0 &&
        field.value[0] !== "0" &&
        e.target.value.length <= 10
      ) {
        return setValue("phone", `0${e.target.value}`);
      }
      if (!e.target.value || e.target.value === "0") {
        return field.onChange(e);
      }
      if (
        e?.target?.validity?.valid &&
        !!Number(e.target.value) &&
        field?.onChange &&
        e.target.value.length <= 10
      ) {
        field.onChange(e);
      }
    },
    [setValue]
  );

  return (
    <>
      {showMobile && (
        <PersonalInformationMobileTab
          controlUser={controlUser}
          onChangeNumber={onChangeNumber}
          handleSubmitUser={handleSubmitUser}
          handleSubmit={handleSubmit}
          onChangeUser={onChangeUser}
          control={control}
          onChangePassword={onChangePassword}
          errors={errors}
        />
      )}
      {!showMobile && (
        <form className="PersonalInformationTab-form-main">
          <div className="PersonalInformationTab-form-otr">
            <div className="PersonalInformation-otr">
              <div className="PersonalInfo-icon-otr">
                <img className="PersonalInfo-icon" src={PersonalInformationIcon1} alt="icon" />
              </div>
              <h3 className="PersonalInfo-heading">מידע אישי</h3>
              <div className="PersonalInfo-Input-otr">
                <Controller
                  name="name"
                  control={controlUser}
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <div className="PersonalInfo-Input-otr">
                        <Input placeholder="שם מלא" {...field} disabled />
                        {errorsUser.name && (
                          <span className="validation-text">{errorsUser.name.message || ""}</span>
                        )}
                      </div>
                    );
                  }}
                />
              </div>
              <div className="PersonalInfo-Input-otr">
                <Input placeholder="דוא”ל" value={client?.email} disabled />
              </div>
              <div className="PersonalInfo-Input-otr">
                <Controller
                  name="phone"
                  control={controlUser}
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <div className="PersonalInfo-Input-otr">
                        <Input
                          placeholder="מספר נייד"
                          type="number"
                          {...field}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                          }
                          onChange={(e) => {
                            onChangeNumber(e, field);
                          }}
                          style={{ direction: "rtl" }}
                          maxLength={10}
                        />
                        {errorsUser.phone && (
                          <span className="validation-text">{errorsUser.phone.message || ""}</span>
                        )}
                        {inccorectPhone && <span className="validation-text">זהו שדה חובה</span>}
                        {!!messageServer?.message && (
                          <span
                            style={{
                              fontSize: 18,
                              color:
                                messageServer?.message === "הפרטים עודכנו בהצלחה" ? "green" : "red"
                            }}>
                            {messageServer?.message}
                          </span>
                        )}
                      </div>
                    );
                  }}
                />
              </div>
              <div className="PersonalInformationTab-action">
                <input
                  className="save-changes-btn"
                  type="submit"
                  name="submit"
                  value="שמור שינויים"
                  onClick={handleSubmitUser(onChangeUser)}
                />
              </div>
            </div>
            <div className="ChangePassword-otr">
              <div className="PersonalInfo-icon-otr">
                <img className="PersonalInfo-icon" src={PersonalInformationIcon2} alt="icon" />
              </div>
              <h3 className="PersonalInfo-heading">שינוי סיסמה</h3>
              <Controller
                name="password"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="PersonalInfo-Input-otr">
                    <PasswordInput
                      placeholder="סיסמה נוכחית"
                      className={`${errors.password ? "invalid-input" : ""}`}
                      {...field}
                    />
                    {errors.password && (
                      <span className="validation-text">{errors?.password.message || ""}</span>
                    )}
                  </div>
                )}
              />
              <Controller
                name="newPass"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="PersonalInfo-Input-otr">
                    <PasswordInput
                      placeholder="סיסמה חדשה"
                      className={`${errors.newPass ? "invalid-input" : ""}`}
                      {...field}
                    />
                    {errors.newPass && (
                      <span className="validation-text">{errors?.newPass.message || ""}</span>
                    )}
                  </div>
                )}
              />
              <Controller
                name="repeatPass"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="PersonalInfo-Input-otr">
                    <PasswordInput
                      placeholder="אימות סיסמה חדשה"
                      className={`${errors.repeatPass ? "invalid-input" : ""}`}
                      {...field}
                    />
                    {!!errors.repeatPass && (
                      <span className="validation-text">{errors?.repeatPass.message || ""}</span>
                    )}
                    {!!messageServerPass?.message && (
                      <span className="validation-text">*{messageServerPass?.message || ""}</span>
                    )}
                  </div>
                )}
              />
              <div className="PersonalInformationTab-action">
                <input
                  className="save-changes-btn"
                  type="submit"
                  name="submit"
                  value="שנה סיסמה"
                  onClick={handleSubmit(onChangePassword)}
                />
              </div>
            </div>
          </div>
        </form>
      )}
      <Modal
        show={modalPass}
        onHide={onCloseModal}
        backdrop="static"
        keyboard={false}
        centered
        animation={false}
        scrollable
        className="modal-change-password">
        <div
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            flex: 1
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
              position: "absolute",
              top: 40,
              left: 40
            }}>
            <div style={{ left: 20, top: 20, cursor: "pointer" }} onClick={onCloseModal}>
              <img src={CrossPink} />
            </div>
          </div>
          <div
            style={{
              paddingLeft: 120,
              paddingRight: 120
            }}>
            <h1
              style={{
                color: "rgba(72, 30, 160, 1)",
                fontSize: 48,
                fontWeight: 700
              }}>
              שינוי סיסמה
            </h1>
            <span style={{ fontSize: 24, fontWeight: 400, color: "rgba(16, 23, 50, 1)" }}>
              הסיסמה שונתה בהצלחה
            </span>
            <Button
              text="אישור"
              style={{
                marginTop: 30,
                background: "rgba(255, 99, 96, 1)",
                height: 60,
                padding: 0,
                width: 400
              }}
              onClick={onCloseModal}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default PersonalInformationTab;
